import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Specialties() {
  return <section className="bg-white py-12 sm:py-16 md:py-20 lg:py-24" data-id="element-274">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-275">
        <div className="mb-8 sm:mb-12 md:mb-16" data-id="element-276">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl md:text-5xl" data-id="element-277">
            Nuestros servicios constructivos
          </h2>
          <p className="mt-3 sm:mt-4 max-w-3xl text-base sm:text-lg md:text-xl text-gray-500" data-id="element-278">
            Nos especializamos en la construcción y habilitación de espacios
            corporativos y comerciales, adaptando cada proyecto a las
            necesidades operativas y estándares de marca de nuestros clientes.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:gap-8 lg:gap-10 lg:grid-cols-2" data-id="element-279">
          {/* Oficinas Block */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="group relative overflow-hidden rounded-[2rem] sm:rounded-[2.5rem] bg-gray-50" data-id="element-280">
            <div className="aspect-[16/9] w-full overflow-hidden" data-id="element-281">
              <img src="https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&q=80&w=1200" alt="Oficinas corporativas" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-282" />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent" data-id="element-283" />
            </div>
            <div className="absolute bottom-0 left-0 p-6 sm:p-8 md:p-10 w-full" data-id="element-284">
              <h3 className="mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold text-white" data-id="element-285">
                Oficinas
              </h3>
              <ul className="space-y-2 sm:space-y-3" data-id="element-286">
                {['Habilitación corporativa', 'Remodelaciones', 'Estándares de marca'].map(item => <li key={item} className="flex items-center text-gray-200 font-medium text-sm sm:text-base" data-id="element-287">
                    <CheckCircle2 className="mr-3 h-5 w-5 text-blue-400" data-id="element-288" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </motion.div>

          {/* Retail Block */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="group relative overflow-hidden rounded-[2rem] sm:rounded-[2.5rem] bg-gray-50" data-id="element-289">
            <div className="aspect-[16/9] w-full overflow-hidden" data-id="element-290">
              <img src="https://images.unsplash.com/photo-1567449303078-57a67168a66a?auto=format&fit=crop&q=80&w=1200" alt="Espacio de retail" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-291" />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent" data-id="element-292" />
            </div>
            <div className="absolute bottom-0 left-0 p-6 sm:p-8 md:p-10 w-full" data-id="element-293">
              <h3 className="mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold text-white" data-id="element-294">
                Retail
              </h3>
              <ul className="space-y-2 sm:space-y-3" data-id="element-295">
                {['Locales comerciales', 'Strip centers', 'Sucursales bancarias'].map(item => <li key={item} className="flex items-center text-gray-200 font-medium text-sm sm:text-base" data-id="element-296">
                    <CheckCircle2 className="mr-3 h-5 w-5 text-indigo-400" data-id="element-297" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}